import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';

const StatisticData = ({ tableData, opk }) => {
  const valueConvert = (val, item) => {
    let prec=0
    if(item === '% wykorzystania łóżek'||item === 'Średni czas pobytu w dniach') prec = 2
    let value = val
    if(val&&typeof value === typeof 1){
      value = value.toFixed(prec).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
    }
    if(item === '% wykorzystania łóżek') value+='%'
    return value
  }

  let mainCode = opk.split('-')[0], statsRows = []
    switch(mainCode){
      case '500':
      case '501':
        statsRows =['Liczba wykonanych porad']
        break;
      case '504':
        statsRows = ["Liczba łóżek","Liczba hospitalizowanych pacjentów","Liczba wykonanych osobodni","% wykorzystania łóżek","Średni czas pobytu w dniach"]
        // {
        //   "Liczba łóżek":"liczba łóżek",
        //   "Liczba hospitalizowanych pacjentów":"liczba hospitalizowanych pacjentów", 
        //   "Liczba wykonanych osobodni":"liczba wykonanych osobodni",
        //   '% wykorzystania łóżek':'% wykorzystania łóżek',
        //   'Średni czas pobytu w dniach':'średni czas pobytu w dniach'
        // }
        break;
      case '507':
        statsRows = ['Liczba wykonanych procedur medycznych']
        break;
      case '530':
      case '535':
        statsRows = ['Liczba wykonanych usług']
        break;
      default:
        break
    }
 
 
  if(tableData){
    
    return (
      <div className=''>
        <table className='table' id="statistic">
          <thead className=''>
            
          </thead>
          <tbody className='rt-tbody'>
          {statsRows.map((item, i) => {
              return (<tr key={`rep2-${i}`} className='rt-tr' >
                <td className='tdTitles ' style={i===0?{borderTop:"none", borderBottom:"1px solid #dee2e6"}:{borderBottom:"1px solid #dee2e6"}}>{item}</td>
                <td className="rightAlignCell"  style={i===0?{borderTop:"none", width:"40%",  borderBottom:"1px solid #dee2e6"}:{width:"40%",  borderBottom:"1px solid #dee2e6"}}>{valueConvert(tableData[item], item)}</td>
              </tr>)
            })}
          </tbody>
        </table>
      </div>
    )
  }else{
    return <Spinner/>
  }
}
StatisticData.propTypes = {
  tableData: PropTypes.object
}
export default StatisticData
